<template>
	<div>
		<h2 class="">{{ item.title }}</h2>
		<back></back>
		<div class="wh-block" v-if="!start">
			<instructions></instructions>
		</div>
		<game v-if="start"></game>
	</div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    provide(){
      return {
        module_name: this.module_name
      }
    },
    name: "start",
    data() {
      return {
        module_name: 'gorbov'
      }
    },
    watch: {
      //'start': 'scroll'
    },
    components: {
      'instructions': require('./instructions').default,
      'game': require('./game').default,
      'finish': require('./finish').default,
    },
    computed: {
      ...mapState({
        item: state => state.current_trainer,
        start: state => state.train.gorbov_params.start,
        finish: state => state.train.gorbov_params.finish,
      })
    },
    methods: {
      commitVal(value, param, method = 'gorbov') {
        let val = {
          train:  method + '_params',
          param_name: param,
          param_val: value
        }
        this.$store.commit('train/changeParam', val);
      },
      scroll(){
        if(this.start){
          setTimeout(function () {
            UIkit.scroll('.headline2').scrollTo('.train__info');
          }, 200)
        }
      },
    }
  }
</script>